/*
 * Copyright Evollis 2021
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */
import { formatFrenchPhoneNumber, isFrenchPhoneNumber, isStrangerTenant } from "../../../core/utils"
import Bloc from "./Bloc"
import Field from "./Field"
import React from "react"

export default function CoordinatesBloc({ configuration, values, tunnelData }) {
  const { tenant } = tunnelData
  let { coordinates, leaderCoordinates } = configuration

  coordinates = coordinates ? coordinates : leaderCoordinates

  const phoneNumberByCountry = (phoneNumber) => {
    if (isStrangerTenant(tenant)) {
      return "+" + phoneNumber
    } else {
      if (isFrenchPhoneNumber(phoneNumber)) {
        return formatFrenchPhoneNumber(phoneNumber)
      } else {
        return phoneNumber
      }
    }
  }

  return (
    <Bloc hide={!coordinates} name={leaderCoordinates ? "Leader coordinates" : "My coordinates"}>
      <Field hide={!coordinates?.includes("address")} name={"Address"} value={values.coordinates.address} />
      <Field
        hide={!coordinates?.includes("additionalAddress") || values.coordinates.additionalAddress == null}
        name={"Address 2"}
        value={values.coordinates.additionalAddress}
      />
      <Field
        hide={!coordinates?.includes("locality") || values.coordinates.locality == null}
        name={"Locality"}
        value={values.coordinates.locality}
      />
      <Field hide={!coordinates?.includes("postalCode")} name={"Zip"} value={values.coordinates.postalCode} />
      <Field
        hide={!coordinates?.includes("city")}
        name={"City"}
        value={values.coordinates.city?.label ? values.coordinates.city?.label : values.coordinates.city}
      />
      <Field
        hide={!coordinates?.includes("province")}
        name={"Province"}
        value={values.coordinates.province?.label ? values.coordinates.province?.label : values.coordinates.province}
      />
      <Field
        hide={!coordinates?.includes("countryOfResidence")}
        name={"Country of residence"}
        value={values.coordinates.countryOfResidence?.label}
      />
      <Field
        hide={!coordinates?.includes("phoneNumber")}
        name={"Mobile"}
        value={phoneNumberByCountry(values.coordinates.phoneNumber)}
      />
      <Field
        hide={!coordinates?.includes("fixePhoneNumber") || values.coordinates.fixePhoneNumber == null}
        name={"Landline"}
        value={values.coordinates.fixePhoneNumber}
      />
      <Field hide={!coordinates?.includes("email")} name={"Email"} value={values.coordinates.email} />
      <Field hide={!coordinates?.includes("iban")} name={"IBAN"} value={values.coordinates.iban} />
      <Field hide={!coordinates?.includes("bic")} name={"BIC or SWIFT"} value={values.coordinates.bic} />
      <Field
        hide={!coordinates?.includes("yearBankSeniority")}
        name={"Bank Seniority"}
        value={values.coordinates.yearBankSeniority}
      />
    </Bloc>
  )
}
